import React, { useMemo } from 'react';
import { MicrosoftOAuthContext } from './context';

export default function MicrosoftOAuthProvider({
    clientId,
    children,
}) {
    const contextValue = useMemo(() => ({
        clientId,
    }), [clientId]);

    return (
        <MicrosoftOAuthContext.Provider value={contextValue}>
            {children}
        </MicrosoftOAuthContext.Provider>
    );
}


